// extracted by mini-css-extract-plugin
export default {"heading":"heading-AxGs9","editButton":"editButton-r3C1M","editLabel":"editLabel-PfMnW"};